module.exports = __webpack_public_path__ + "static/23-0801dd634a1de0999f7c99c2072c4100.png";